import { CommunityGroupHeaderActions } from '../communityGroupHeaderActions'
import { CommunityGroupHeaderProps } from './communityGroupHeader.types'

const CommunityGroupHeader = ({ group }: CommunityGroupHeaderProps) => {
  return (
    <div className="_d-flex _align-items-center _justify-content-between _flex-1 _position-relative _py-2">
      <span className="_font-14 _text-gray-900 _font-weight-bold">{group.name}</span>
      <CommunityGroupHeaderActions group={group} />
    </div>
  )
}

export default CommunityGroupHeader
